<div
    class="sidebar"
    [ngClass]="{
        'sidebar--expanded': sidebarService.isMobileMenuOpen(),
    }"
>
    <button
        data-application="sidebar-mobile-toggle"
        class="sidebar__mobile-toggle"
        (click)="sidebarService.toggleMobileMenu()"
    >
        {{ 'Table of contents' | translate }}
    </button>
    <div class="sidebar__content" #scrollContent [style.top.px]="stickyService.totalStuckHeight() + 30">
        <div class="sidebar__search">
            @if (sidebarSetting.hasSearch) {
                <website-search-input
                    [actionEnter]="true"
                    [inputSize]="'small'"
                    inputPlaceholder="{{ 'Search FAQ, resources...' | translate }}"
                ></website-search-input>
            }
        </div>
        <nav class="sidebar__menu">
            @if (sidebarSetting?.headerTitle) {
                <website-menu-item [item]="menuItem"></website-menu-item>
            }
            <website-menu-items-list
                [navigationItems]="sidebarSetting?.navigationItems"
                [level]="0"
            ></website-menu-items-list>
        </nav>
    </div>

    @if (sidebarService.isMobileMenuOpen()) {
        <div class="sidebar__overlay" (click)="sidebarService.hideMobileMenu()"></div>
    }
</div>
